import { LoadState } from "../../constants/enums";

export interface IMasterDropdownsState {
  data: {
    list: IMasterDropdown[];
    loading: LoadState;
  };
  runtimeRefData: {
    [code: string]: {
      list: { label: string; value: string }[];
    };
  };
}

export interface IMasterDropdown {
  dropdown_code: string;
  module_name: string;
  sub_module_name: string;
  section: string;
  options: { label: string; value: string }[];
  status: string;
}

export const initialMasterDropdownsState: IMasterDropdownsState = {
  data: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  runtimeRefData: {},
};
